<template lang="pug">
.logo-page(@click='logoGlow')
  img(
    @animationend='onAnimationEnd'
    :src='logoSrc'
    :class=`{
      'is-glowing': currentStep === 'glow',
      'is-scaling': currentStep === 'scale'
      }`
    :style=`{
      '--glow-duration': DURATION.GLOW,
      '--scale-duration': DURATION.SCALE
      }`
    )
</template>

<script>
export default {
  data () {
    return {
      logoSrc: require('@/assets/logo-288-x-294-mixed.svg'),
      currentStep: 'idle', // idle, glow, scale
      DURATION: { GLOW: '3s', SCALE: '2s' }
    }
  },
  methods: {
    logoGlow () {
      if (this.currentStep !== 'idle') return
      this.currentStep = 'glow'
      this.$emit('showBg')
    },
    onAnimationEnd (e) {
      if (e.animationName === 'showGlow') {
        this.currentStep = 'scale'
      } else if (e.animationName === 'showScale') {
        this.currentStep = null
        this.$emit('next')
      }
    }
  }
}
</script>

<style lang="scss">
.logo-page {
  width: 100%;
  height: 100%;
  position: relative;

  img {
    margin: 0 auto;
    position: absolute;
    top: 31.25vh;
    left: 50%;
    transform: translateX(-50%) scale(1);
    opacity: 1;

    &.is-glowing {
      filter: drop-shadow(0px 0px 60px transparent);

      animation-name: showGlow;
      animation-duration: var(--glow-duration, 3s);
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }

    &.is-scaling {
      animation-name: showScale;
      animation-duration: var(--scale-duration, 2s);
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }
  }
}

@keyframes showScale {
  from {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }

  to {
    transform: translateX(-50%) scale(3);
    opacity: 0;
  }
}

@keyframes showGlow {
  from {
    filter: drop-shadow(0px 0px 60px transparent);
  }

  50% {
    filter: drop-shadow(0px 0px 60px gold);
  }

  75% {
    filter: drop-shadow(0px 0px 60px gold);
  }

  to {
    filter: drop-shadow(0px 0px 60px transparent);
  }
}
</style>
